import { render, staticRenderFns } from "./Dialog_ChooseSpecialClassPackageDetail.vue?vue&type=template&id=ef7e3afc&scoped=true&"
import script from "./Dialog_ChooseSpecialClassPackageDetail.vue?vue&type=script&lang=js&"
export * from "./Dialog_ChooseSpecialClassPackageDetail.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_ChooseSpecialClassPackageDetail.vue?vue&type=style&index=0&id=ef7e3afc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7e3afc",
  null
  
)

export default component.exports